import { createContext } from 'react';
import type { PaymentsContextValue } from './types';

export const PaymentsContext = createContext<PaymentsContextValue | null>(null);
